import {Post} from "@kkmh/utils";

export default () => {
    return Post({
        url:"/v1/passport/login/pc/user_log_out",
        data:{}
    });
};



// WEBPACK FOOTER //
// ./src/pages/native/pay/vip/link_vip_multiple/api/logout.js